import React from 'react'
export const Footer = () => {
  return (
    <footer  className="footer">
        <div className="footer_info">
        Copyright - <a href="http://globalgas.mx" target='_blank'>globalgas.mx</a> 2023
        </div>
      </footer>
  )
}
